import { createReducer, on } from "@ngrx/store";
import { permissionsInitialState } from "./permissions.state";
import * as permissionsActions from "./permissions.actions";
import * as _ from "lodash";


export const permissionsReducer = createReducer(
  permissionsInitialState,
  on(permissionsActions.setPermissions, (state, { permissions, locations, species }) =>({
    ..._.cloneDeep(state),
    initialState: false,
    permissions,
    locations,
    species
  })),
  on(permissionsActions.getPermissions, (state) =>({
    ..._.cloneDeep(state)
  })),
  on(permissionsActions.resetPermissions, (state) =>({
    ..._.cloneDeep(state),
    ..._.cloneDeep(permissionsInitialState)
  }))
);
